import {getScroll} from '../../helpers/_utilities';
import gsap from 'gsap';
import variables from '../../variables';


const {
	toTopButton
} = variables.selectors;

const
	show = () => {
		gsap.to(toTopButton, {
			yPercent: 0,
			autoAlpha: 1
		})
	},
	hide = () => {
		gsap.to(toTopButton, {
			yPercent: 50,
			autoAlpha: 0
		})
	},
	offset = variables.windowHeight
;


let buttonIsVisible = getScroll().y < offset;

export default function buttonToUpOnScroll(event) {
	let y;

	if (event instanceof Event) {
		y = getScroll().y;
	} else if (typeof event === 'number') {
		y = event;
	}

	if (y > offset) {
		if (!buttonIsVisible) {
			show();
			buttonIsVisible = true
		}
	} else {
		if (buttonIsVisible) {
			hide();
			buttonIsVisible = false
		}
	}
}
